








import VueOptions from '@utils/VueOptions'


settings =
  name: 'Stats'
  vue:
    props: ['stats']
    computed:
      statsArray: -> @statsToArray()
    methods:
      getEventSetStats: (eventSet) ->
        stats = []
        stats.push({ name: "Total", value: eventSet.count })
        return stats
      getEventStats: (event) ->
        stats = []
        stats.push({ name: "Total", value: event.count })
        stats.push({ name: "Draft", value: event.draft_count })
        stats.push({ name: "Listed", value: event.listed_count })
        stats.push({ name: "Recess Verified", value: event.recess_verified_count })
        stats.push({ name: "Canceled", value: event.canceled_count })
        stats.push({ name: "Deactivated", value: event.deactivated_count })
        stats.push({ name: "Published", value: event.published_count })
        stats.push({ name: "Unpublished", value: event.unpublished_count })
        return stats
      getOfferStats: (offer) ->
        stats = []
        stats.push({ name: "Total", value: offer.count })
        stats.push({ name: "Draft", value: offer.draft_count })
        stats.push({ name: "Submitted", value: offer.submitted_count })
        stats.push({ name: "Accepted", value: offer.accepted_count })
        stats.push({ name: "Denied", value: offer.denied_count })
        stats.push({ name: "In Revision", value: offer.in_revision_count })
        stats.push({ name: "Ignored", value: offer.ignored_count })
        stats.push({ name: "Canceled", value: offer.canceled_count })
        stats.push({ name: "Expired", value: offer.expiring_count })
        stats.push({ name: "Pending", value: offer.pending_count })
        stats.push({ name: "Advanced", value: offer.advancing_count })
        stats.push({ name: "Future", value: offer.future_count })
        stats.push({ name: "Past", value: offer.past_count })
        return stats
      getOrganizerStats: (organizer) ->
        stats = []
        stats.push({ name: "Total", value: organizer.count })
        stats.push({ name: "Member", value: organizer.member_count })
        stats.push({ name: "Unregistered", value: organizer.unregistered_count })
        return stats
      getActivationStats: (activation) ->
        stats = []
        stats.push({ name: "Total", value: activation.count })
        return stats
      statsToArray: ->
        array = []

        if @stats.event_set
          array = array.concat({ title: "Event Sets", stats: @getEventSetStats(@stats.event_set) })

        if @stats.event
          array = array.concat({ title: "Events", stats: @getEventStats(@stats.event) })

        if @stats.offer
          array = array.concat({ title: "Offers", stats: @getOfferStats(@stats.offer) })

        if @stats.organizer
          array = array.concat({ title: "Organizers", stats: @getOrganizerStats(@stats.organizer) })

        if @stats.activation
          array = array.concat({ title: "Activations", stats: @getActivationStats(@stats.activation) })

        array


export default VueOptions.vue settings
